import type TranslationsConfigType from './translation-type';

const nbTranslations: TranslationsConfigType = {
    tryAgain: 'Prøv igjen',
    showLess: 'Vis mindre',
    showMore: 'Vis mer',
    cancel: 'Avbryt',
    errors: {
        somethingWentWrong: 'Noe gikk galt!',
        ohNo: 'Å nei!',
        oops: 'Oj sann!',
        timeoutMessage: 'Vi beklager, det tok litt lenger tid enn vi hadde tenkt. Du må gjerne prøve igjen',
        defaultMessage: 'Vi beklager, det skjedde en teknisk feil. Vennligst prøv igjen litt senere.',
    },
    header: 'Hei på deg',
    buttonText: 'Knappen',
    ekstraText: 'Todo',
    ok: 'Ok',
    yourSavings: 'Din sparing',
    developmentOverTime: 'Utvikling over tid',
    savedAmountInXYears: 'Oppspart beløp om {} år',
    startSavingNow: {
        title: 'Kom i gang med sparingen',
        saveInFund: 'Spar i fond',
        contactAdvisor: 'Kontakt en rådgiver',
    },
    inputs: {
        initialInvestment: 'Startbeløp',
        monthlyContribution: 'Månedlig beløp',
        savingPeriodYears: 'Spareperiode',
        compareWithSavingsAccountCheckbox: 'Sammenligne med sparekonto',
    },
    heroSummary: {
        expectedValueInXYears: 'Forventet verdi om {} år',
        increaseLabel: 'Verdiøkning',
    },
    totalsPanel: {
        profitTagA11yTotal: 'Total avkastning: {}',
        profitTagA11yPercent: 'Prosentvis avkastning: {}',
        aboutCalculationsLinkText: 'Om beregningen',
        totalInvestmentLabel: 'Beløp spart',
        fundLabel: 'Aksjefond',
        savingsAccountLabel: 'Sparekonto',
        expectedTotalValueLabel: 'Forventet totalverdi',
        increasePercentageLabel: 'Verdiøkning %',
        increaseAmountLabel: 'Verdiøkning kr',
        interestPercentageLabel: 'Renter %',
        interestAmountLabel: 'Renter kr',
    },
    aboutCalculations: {
        modalTitle: 'Om beregningen',
        interestRateCalculation:
            'Kalkulatoren sammenligner forventet utvikling på en spare\u00ADkonto med utviklingen til et fiktivt aksjefond. Forventet utvikling er basert på:',
        bulletPoint1: '{} i rente på sparekonto',
        bulletPoint2: '{} i årlig avkastning på fond',
        basedOnFinansNorge:
            'Avkastnings\u00ADforventningene vi bruker i modellen, er basert på prognoser for verdi\u00ADøknings\u00ADforventninger fra Finans Norge.',
        inflationHeader: 'Inflasjon er ikke fratrukket',
        inflationDescription: 'Du bør regne med en inflasjon på ca. {}.',
        whatIsInflation: 'Hva er inflasjon?',
        whatIsInflationDescription1:
            'Inflasjon er det som skjer når verdien av kronen endrer seg over tid. For eksempel så koster en kroneis i dag mye mer enn den gjorde før i tiden.',
        whatIsInflationDescription2:
            'Når du slår på inflasjonsjustering, så vil beløpet i utregningen gjøres lavere, slik at du får et mer realistisk bilde av den faktiske verdien som pengene kommer til å ha når du skal bruke pengene.',
        verdiutviklingHeader: 'Forventede variasjoner i verdiutviklingen',
        verdiutviklingDescription:
            'Verdiutvikling kan bli høyere eller lavere enn forentet. Grafen viser forventede svingninger fra lav til høy verdiutviklling.',
        verdiutviklingHigh: 'Høy',
        verdiutviklingExpected: 'Forventet',
        verdiutviklingLow: 'Lav',
        taxNotIncludedHeader: 'Skatt er ikke iberegnet',
        taxNotIncludedDescription:
            'Utregningen har ikke hensyntatt eventuell skatt som vil kunne påhvile produktet og/eller kunden. Den skattemessige virkningen avhenger av den enkelte kundes individuelle situasjon og kan komme til å endre seg.',
        noGuaranteeHeader: 'Verdiøkning er ingen garanti',
        noGuaranteeDescription:
            'Forventet avkastning er ingen garanti for fremtidig avkastning. Fremtidig avkastning vil blant annet avhenge av markeds\u00ADutviklingen, forvalterens dyktighet, fondets risikoprofil og tegnings- og forvaltningshonorar. Avkastningen kan bli negativ som følge av kurstap.',
        weUseFinansNorge:
            'Vi bruker bransje\u00ADorganisasjonen Finans Norges til enhver tid gjeldende verdiøknings\u00ADforventninger i våre utregninger.',
        finansNorgeLink: 'Finans Norge prognoser',
    },
};

export default nbTranslations;
